/**
 * FAQ Page interactive script
 *
 * Handles category filtering and smooth accordion toggle animations.
 */

document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.faq-section__tab');
  const items = document.querySelectorAll('.faq-item');

  if (!tabs.length || !items.length) {
    return;
  }

  /**
   * Closes an accordion item cleanly with transition.
   *
   * @param {HTMLElement} item
   */
  const closeAccordion = (item) => {
    const header = item.querySelector('.faq-item__header');
    const body = item.querySelector('.faq-item__body');
    if (!header || !body) return;

    item.classList.remove('faq-item--active');
    header.setAttribute('aria-expanded', 'false');
    body.setAttribute('aria-hidden', 'true');
    body.style.maxHeight = '0';
  };

  /**
   * Opens an accordion item cleanly with transition.
   *
   * @param {HTMLElement} item
   */
  const openAccordion = (item) => {
    const header = item.querySelector('.faq-item__header');
    const body = item.querySelector('.faq-item__body');
    if (!header || !body) return;

    item.classList.add('faq-item--active');
    header.setAttribute('aria-expanded', 'true');
    body.setAttribute('aria-hidden', 'false');
    body.style.maxHeight = `${body.scrollHeight}px`;
  };

  // ─── Accordion Toggle Click Handlers ─────────────────────────────────────
  items.forEach((item) => {
    const header = item.querySelector('.faq-item__header');
    const body = item.querySelector('.faq-item__body');

    if (header && body) {
      header.addEventListener('click', () => {
        const isOpen = item.classList.contains('faq-item--active');

        if (isOpen) {
          closeAccordion(item);
        } else {
          // Close other active items to provide a clean single-open behavior
          items.forEach((otherItem) => {
            if (
              otherItem !== item &&
              otherItem.classList.contains('faq-item--active')
            ) {
              closeAccordion(otherItem);
            }
          });
          openAccordion(item);
        }
      });
    }
  });

  // ─── Filter Tabs Click Handlers ──────────────────────────────────────────
  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const filter = tab.getAttribute('data-filter');

      // Update active tab buttons visually and semantically
      tabs.forEach((t) => {
        t.classList.remove('faq-section__tab--active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('faq-section__tab--active');
      tab.setAttribute('aria-selected', 'true');

      // Filter and animate the accordion list items
      let visibleCounter = 1;
      items.forEach((item) => {
        const itemCategory = item.getAttribute('data-category');

        // Always collapse active accordions on tab changes to ensure consistency
        closeAccordion(item);

        if (filter === 'all' || itemCategory === filter) {
          // Remove hidden class to trigger CSS transition
          item.classList.remove('faq-item--hidden');

          // Clear any inline styles of opacity/transform that could interfere with CSS
          item.style.removeProperty('opacity');
          item.style.removeProperty('transform');

          // Set staggered delay for showing items to make the entry super premium
          const delay = (visibleCounter - 1) * 50; // 50ms stagger
          item.style.transitionDelay = `${delay}ms`;

          // Update item index sequence dynamically
          const numberElement = item.querySelector('.faq-item__number');
          if (numberElement) {
            numberElement.textContent = `${visibleCounter}.`;
          }
          visibleCounter++;
        } else {
          // Hide immediately/without delay and clear inline styles
          item.style.transitionDelay = '0ms';
          item.style.removeProperty('opacity');
          item.style.removeProperty('transform');
          item.classList.add('faq-item--hidden');
        }
      });
    });
  });

  // ─── Handle Window Resize (recalculate height for active panels) ────────
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const activeItems = document.querySelectorAll('.faq-item--active');
      activeItems.forEach((item) => {
        const body = item.querySelector('.faq-item__body');
        if (body) {
          body.style.maxHeight = `${body.scrollHeight}px`;
        }
      });
    }, 100);
  });
});
